<mat-sidenav-container
  class="bg-card flex min-w-0 flex-1 flex-col dark:bg-transparent sm:absolute sm:inset-0"
>
  <div
    class="bg-card flex flex-1 flex-col min-w-0"
    [ngStyle]="{ height: 'calc(100vh - 290px)' }"
  >
    <div class="flex flex-row w-full">
      <div
        *ngIf="listColletionDefaultKeys?.length > 0"
        class="flex flex-col pt-18 pl-2 bg-gray-100 pr-2"
      >
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Compañia</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Division</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md pt-2">Tipo de Material</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Cadenas de Distribución</label>
        </div>

        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Tipo de Socios de Negocio</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md"
            >Tpo. de cltes. de socios comerciales</label
          >
        </div>

        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Ruta de Area</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Tipo de Dirección</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md"
            >Func. de Cont. de Socio Comercial</label
          >
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Condición de Pago</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Aplicaciones</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Sub Aplicaciones</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Organizacion de Ventas</label>
        </div>
        <div class="!h-[60px] !w-[170px] flex items-center">
          <label class="font-semibold text-md">Divisa</label>
        </div>
      </div>
      <div class="flex flex-row overflow-x-auto flex-1">
        <ng-container *ngFor="let item of listColletionDefaultKeys">
          <ng-container
            *ngTemplateOutlet="formDefaultKeys; context: { $implicit: item }"
          ></ng-container>
        </ng-container>
      </div>
    </div>

    <div
      *ngIf="listColletionDefaultKeys?.length === 0"
      class="flex-1 flex self-center justify-center items-center"
    >
      <p class="font-semibold">Lo sentimos, no hay registros para mostrar.</p>
    </div>
  </div>
</mat-sidenav-container>

<ng-template #formDefaultKeys let-data>
  <div
    [formGroup]="data.currentUpdate"
    class="flex flex-col pb-5 flex-shrink-0 flex-grow"
  >
    <div class="flex h-15 min-w-[170px] bg-gray-100 pr-5 mb-3 pl-3">
      <h2 class="text-md font-semibold self-center">
        {{ data.title }}
      </h2>
    </div>

    <!-- Compañia -->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="company"
          placeholder="Seleccione una compañia"
        >
          <mat-option
            *ngFor="let type of listCompanies || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Divsion -->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="division"
          placeholder="Seleccione una division"
        >
          <mat-option
            *ngFor="let type of listDivisions || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Tipo de material -->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="materialType"
          placeholder="Seleccione una tipo de material"
        >
          <mat-option
            *ngFor="let type of listMaterialType || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Cadenas de Distribucion -->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="distributionChainIds"
          placeholder="Seleccione una cadena de distribución"
          multiple="true"
        >
          <mat-option
            *ngFor="let type of listDistributionChain || []"
            [value]="type.id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--Tipo Socios de negocio -->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="businessPartnerTypes"
          placeholder="Seleccione un tipo socio de negocio"
          multiple="true"
        >
          <mat-option
            *ngFor="let type of listBusinessPartnerType || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!--Tipos de clientes de socios comerciales -->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="businessPartnerCustomerTypes"
          placeholder="Seleccione tipos de clientes de socios comerciales"
          multiple="true"
        >
          <mat-option
            *ngFor="let type of listBusinessPartnerType || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--Ruta de Area-->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="routeArea"
          placeholder="Seleccione una ruta de area"
        >
          <mat-option
            *ngFor="let type of listRouteArea || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Tipo de Dirección-->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="addressType"
          placeholder="Seleccione una tipo de dirección"
        >
          <mat-option
            *ngFor="let type of listAdressType || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Función de contacto de socio comercial-->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="businessPartnerContactFunction"
          placeholder="Seleccione una función de contacto de socio comercial"
        >
          <mat-option
            *ngFor="let type of listBusinessPartnerCF || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Condición de Pago-->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="paymentCondition"
          placeholder="Seleccione una condición de pago"
          [disableOptionCentering]="true"
          (openedChange)="onDropdownOpened($event)"
        >
          <!-- Campo de búsqueda -->
          <mat-option>
            <div class="w-full">
              <input
                class="w-full p-2 border border-gray-300 rounded-md focus:outline-none"
                (keyup)="filterOptions($event)"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                placeholder="Buscar..."
              />
            </div>
          </mat-option>

          <mat-option
            *ngFor="let type of listFilterPaymentCondition || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Aplicaciones-->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="applicationsIds"
          placeholder="Seleccione una aplicación"
          multiple="true"
        >
          <mat-option
            *ngFor="let type of listApplication || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Sub Aplicaciones-->
    <div class="h-[60px]min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="subApplicationsIds"
          placeholder="Seleccione una sub aplicación"
          multiple="true"
        >
          <mat-option
            *ngFor="let type of listSubAplication || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--Organizacion de Ventas-->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="salesOrganization"
          placeholder="Seleccione una organizacion de ventas"
        >
          <mat-option
            *ngFor="let type of listSalesOrganization || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--Organizacion de Ventas-->
    <div class="h-[60px] min-w-[170px] mr-2 ml-3">
      <mat-form-field appearance="fill" class="w-full">
        <mat-select
          formControlName="currency"
          placeholder="Seleccione una divisa"
        >
          <mat-option
            *ngFor="let type of listCurrency || []"
            [value]="type._id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-icon
      color="primary"
      class="self-center text-5xl w-20 mt-3"
      matTooltip="Guardar"
      (click)="onHandleSave(data.currentUpdate, data._id)"
      >save</mat-icon
    >
  </div>
</ng-template>
